import PropTypes from 'prop-types';
import Image from '@plone/volto/components/theme/Image/Image';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import ContactCardView from '../../ContactCardView/ContactCardView';
import { homepageImageSources } from '../../../helpers/homepageUtils';

const HomepageContactBody = ({ data, editPreview = false }) => {
  const background = homepageImageSources(data.background, {
    minWidth: 800,
    fallback: 'large',
  });

  return (
    <div className="contact-container">
      {background.src ? (
        <Image
          className="contact-background"
          src={background.src}
          srcSet={background.srcSet}
          sizes="100vw"
          alt=""
          width={background.width}
          height={background.height}
          loading="lazy"
        />
      ) : null}
      <ContactCardView content={data} editPreview={editPreview} />
    </div>
  );
};

HomepageContactBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  editPreview: PropTypes.bool,
};

const View = ({ data, className, editPreview = false }) => (
  <div className={className}>
    <HomepageContactBody data={data} editPreview={editPreview} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
  editPreview: PropTypes.bool,
};

export default withBlockExtensions(View);
export { HomepageContactBody };
